// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/shortened-runway-phraseology.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/shortened-runway-phraseology/shortened-runway-phraseology.js';

mount([g0]);
